import { render, staticRenderFns } from "./ContactGrideComponent.vue?vue&type=template&id=31e27621&scoped=true"
import script from "./ContactGrideComponent.vue?vue&type=script&lang=js"
export * from "./ContactGrideComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactGrideComponent.vue?vue&type=style&index=0&id=31e27621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e27621",
  null
  
)

export default component.exports